import CityPageTemplate from "../city-template/CityPageTemplate";
import { prescottConfig } from "./data";

export default function PrescottPage() {
  return <CityPageTemplate config={prescottConfig} />;
}